import * as actionTypes from "./actionTypes";

export const showModalLocation = () =>{
  return{
    type: actionTypes.SHOW_MODAL_LOCATION
  }
}

export const hideModalLocation = (data) =>{
  return{
    type: actionTypes.HIDE_MODAL_LOCATION,
    data
  }
}

export const getLocationList = () => {
  return {
    type: actionTypes.GET_LOCATION
  };
};

export const getLocationListSuccess = data => {
  return {
    type: actionTypes.GET_LOCATION_SUCCESS,
    data
  };
};

export const submitLocation = data =>{
  return{
    type: actionTypes.STORE_LOCATION,
    data
  }
} 

export const submitLocationSuccess = data =>{
  return{
    type: actionTypes.STORE_LOCATION_SUCCESS,
    data
  }
} 

export const submitLocationFail = data =>{
  return{
    type: actionTypes.STORE_LOCATION_FAIL,
    data
  }
}
